import React from 'react';
import DataManager from '../Managers/Data';
import TranslationManager from '../Managers/Translation';

import DatePicker from "../Components/DatePicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TableS13.css";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";


const WIDTHS = {
    first: "1.5cm",
    second: "1.9cm",
    small: "1.825cm", // 14.6cm / 8
    assignment: "3.65cm",  // 2 × 1.825cm
    groupNumber: "1.2cm"
};

const DATE_INFINITY = new Date(8640000000000000); // max date
const ROWS_PER_PAGE = 20;

if (!String.format) {
  String.format = function(format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function(match, number) { 
      return typeof args[number] != 'undefined'
        ? args[number] 
        : match
      ;
    });
  };
}

const exportPdf = async (feedbackFn) => {
    const elements = document.querySelectorAll(".print-me");

    if (!elements.length) return;

    // A4 PDF, portrait, millimeters
    const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;

    if (feedbackFn)
        feedbackFn(0);
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];

        const canvas = await html2canvas(element, {
            scale: 2,
            backgroundColor: "#ffffff",
            useCORS: true,
        });

        const imageData = canvas.toDataURL("image/jpeg", 0.8); // lower quality, better compression

        // Fit the captured div within the PDF page while preserving proportions
        const availableWidth = pageWidth - margin * 2;
        const availableHeight = pageHeight - margin * 2;

        let imageWidth = availableWidth;
        let imageHeight = (canvas.height * imageWidth) / canvas.width;

        if (imageHeight > availableHeight) {
            imageHeight = availableHeight;
            imageWidth = (canvas.width * imageHeight) / canvas.height;
        }

        const x = (pageWidth - imageWidth) / 2;
        const y = (pageHeight - imageHeight) / 2;

        if (i > 0) pdf.addPage();

        pdf.addImage(imageData, "JPEG", x, y, imageWidth, imageHeight);
        if (feedbackFn)
            feedbackFn(Math.round((i + 1) / elements.length * 100));
    }

    pdf.save("s13.pdf");
};


function computeSeptember1() {
    const now = new Date();

    const year =
        now.getMonth() < 8 // Jan–Aug (months are 0-based; September = 8)
            ? now.getFullYear() - 2
            : now.getFullYear() - 1;

    const date = new Date(year, 8, 1); // 1 September, local time

    return date;
}

function formatDate(date) {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}


function lastHistoryItemBefore(history, givenDate) {


    const previousItem = history.reduce((latest, item) => {
        if (!item.toDate)
            return latest; // skip items without a toDate
        if (item.toDate >= givenDate)
            return latest;

        if (!latest || item.toDate > latest.toDate)
            return item;
        else
            return latest;
    }, null);

    return previousItem ?? { toDate: "", group: "" };
}

function newHistoryItems(history, givenDate) {
    const newItems = history.filter(item => {
        // Include items that don't have a toDate (the card is on hands)
        if (!item.toDate) return true;
        return item.toDate >= givenDate;
    });

    return newItems;
}

function handleOpenCard(cardNumber) {
    window.open("/app/cards?card=" + encodeURIComponent(cardNumber), "_blank");
}

export default class TableS13 extends React.Component {
    static contextType = DataManager.Context;

    state = {
        cards: [],
        showGroupNumbers: true,
        dateFrom: computeSeptember1(),
        exporting: false,
        exportPercentage: 0,
    }


    constructor(props) {
        super(props);
        //        this.handleOpenCard = this.handleOpenCard.bind(this);
        //        this.getCardRow = this.getCardRow.bind(this);
    }

    componentDidMount() {
        this.refreshList();
    }

    refreshList() {
        this.context.fetchCardList((list) => this.setState({ cards: list.sort((a, b) => String(a.number).localeCompare(String(b.number))) }));
    }


    renderCell({
        key,
        rowSpan,
        colSpan,
        className = "",
        width,
        value = "",
        onClick = null
    }) {
        return (
            <td
                key={key}
                rowSpan={rowSpan}
                colSpan={colSpan}
                className={className}
                style={{ width }}
                role={onClick ? "button" : undefined}
                onClick={onClick}
            >{value}</td>
        );
    }

    renderHeader(translationContext, SHOW_HISTORIES) {
        const rows = [];

        /* Header: 1cm total height */
        rows.push(
            <tr key="header-top">
                {this.renderCell({
                    rowSpan: 2,
                    width: WIDTHS.first,
                    className: "header merged-one-cm",
                    value: translationContext.getTranslation("$s13_number")
                })}


                {this.renderCell({
                    rowSpan: 2,
                    width: WIDTHS.second,
                    className: "header merged-one-cm bold-right",
                    value: translationContext.getTranslation("$s13_last")
                })}

                {Array.from({ length: SHOW_HISTORIES }, (_, group) =>

                    <React.Fragment>
                        {this.state.showGroupNumbers ?
                            this.renderCell({
                                rowSpan: 2,
                                width: WIDTHS.groupNumber,
                                className: "header merged-one-cm",
                                value: translationContext.getTranslation("$s13_group")
                            }) : null
                        }

                        {this.renderCell({
                            key: `header-top-group-${group}`,
                            colSpan: 2,
                            width: WIDTHS.assignment,
                            className: "header half-cm bold-right",
                            value: translationContext.getTranslation("$s13_publisher")
                        })}
                    </React.Fragment>
                )}
            </tr>
        );

        rows.push(
            <tr key="header-bottom">
                {Array.from({ length: SHOW_HISTORIES }, (_, group) => [
                    this.renderCell({
                        key: `header-bottom-${group}-left`,
                        width: WIDTHS.small,
                        className: "header half-cm",
                        value: translationContext.getTranslation("$s13_assign_date")
                    }),
                    this.renderCell({
                        key: `header-bottom-${group}-right`,
                        width: WIDTHS.small,
                        className: "header half-cm bold-right",
                        value: translationContext.getTranslation("$s13_return_date")
                    }),
                ])}
            </tr>
        );
        return rows;
    }

    renderPage(translationContext, iPage, totalPages, SHOW_HISTORIES, ROWS_PER_PAGE) {
        let rows = [];
        rows.concat(this.renderHeader(translationContext, SHOW_HISTORIES));

        /* Body */
        for (let _i = iPage * ROWS_PER_PAGE; _i < (iPage + 1) * ROWS_PER_PAGE /*min: this.state.cards.length*/; _i++) {

            let card = {};
            if (_i < this.state.cards.length)
                card = this.state.cards[_i];
            let history = card.history ?? [];

            history.forEach(item => {
                if (item.fromDate) {
                    item.fromDate = new Date(item.fromDate);
                    item.fromDate = new Date(item.fromDate.getFullYear(), item.fromDate.getMonth(), item.fromDate.getDate());
                }
                if (item.toDate) {
                    item.toDate = new Date(item.toDate);
                    item.toDate = new Date(item.toDate.getFullYear(), item.toDate.getMonth(), item.toDate.getDate());
                }
            });

            history = history.sort((a, b) => {
                let aDate = new Date(a.toDate ?? DATE_INFINITY);
                let bDate = new Date(b.toDate ?? DATE_INFINITY);
                return aDate - bDate;
            });

            let last = lastHistoryItemBefore(history, this.state.dateFrom);
            let current = newHistoryItems(history, this.state.dateFrom);
            if (current.length > SHOW_HISTORIES) {
                last = current[current.length - SHOW_HISTORIES - 1];
                current = current.slice(current.length - SHOW_HISTORIES, current.length);
            }

            while (current.length < SHOW_HISTORIES) {
                current.push({ fromDate: "", toDate: "", group: "" });
            }


            let section = String(_i);
            rows.push(
                <tr key={`section-${section}-top`}>
                    {this.renderCell({
                        rowSpan: 2,
                        width: WIDTHS.first,
                        className: "merged-one-cm section-bottom",
                        value: card.number,
                        onClick: () => { handleOpenCard(card.number) }
                    })}

                    {this.renderCell({
                        rowSpan: 2,
                        width: WIDTHS.second,
                        className: "merged-one-cm bold-right section-bottom",
                        value: formatDate(last.toDate)
                    })}

                    {current.map((item) => [
                        this.state.showGroupNumbers ?
                            this.renderCell({
                                rowSpan: 2,
                                width: WIDTHS.groupNumber,
                                className: "section-bottom",
                                value: item.group
                            }) : null
                        ,
                        this.renderCell({
                            key: `section-${section}-top-group-${item.group}-left`,
                            colSpan: 2,
                            width: WIDTHS.assignment,
                            className: "half-cm bold-right",
                            value: item.who
                        })]
                    )}
                </tr>
            );

            rows.push(
                <tr key={`section-${section}-bottom`}>
                    {current.map((item) => [

                        this.renderCell({
                            key: `section-${section}-bottom-${item.group}-left`,
                            width: WIDTHS.small,
                            className: "half-cm section-bottom",
                            value: formatDate(item.fromDate)
                        }),
                        this.renderCell({
                            key: `section-${section}-bottom-${item.group}-right`,
                            width: WIDTHS.small,
                            className: "half-cm bold-right section-bottom",
                            value: formatDate(item.toDate)
                        }),
                    ])}
                </tr>
            );
        }

        return <React.Fragment>
            <div className="print-me">
                <div>
                    &nbsp;
                </div>
                <div style={{ fontSize: "18px", fontWeight: "bold", fontFamily: "Arial", textAlign: "center", verticalAlign: "middle" }}>{translationContext.getTranslation("$s13_title")}</div>
                {this.state.dateFrom ?
                    <div style={{ fontSize: "16px", fontWeight: "bold", fontFamily: "Arial", textAlign: "left", verticalAlign: "middle" }}>
                        {String.format(translationContext.getTranslation("$s13_from_date"), formatDate(this.state.dateFrom), formatDate(new Date()))}                        
                    </div>
                    : null
                }
                <table className="table-s13" style={{ overflowX: "none" }}>
                    <thead>
                        {this.renderHeader(translationContext, SHOW_HISTORIES)}
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
                {
                    this.state.exporting ?
                        <div style={{ fontSize: "12px", fontFamily: "Arial", textAlign: "right", verticalAlign: "middle" }}>
                            {String.format(translationContext.getTranslation("$s13_page"), iPage+1, totalPages)}
                        </div>
                        : null
                }
            </div>

        </React.Fragment>;
    }

    renderPages(translationContext, SHOW_HISTORIES, ROWS_PER_PAGE) {
        let nPages = 1;
        let pages = [];
        if (this.state.exporting) {
            nPages = Math.floor(this.state.cards.length / ROWS_PER_PAGE);
            if (this.state.cards.length % ROWS_PER_PAGE != 0)
                nPages++;
            for (let iPage = 0; iPage < nPages; iPage++) {
                pages.push(this.renderPage(translationContext, iPage, nPages, SHOW_HISTORIES, ROWS_PER_PAGE));
            }
        }
        else {
            pages.push(this.renderPage(translationContext, 0, 1, SHOW_HISTORIES, this.state.cards.length));
        }
        return pages;
    }

    render() {

        let SHOW_HISTORIES = 4;
        if (this.state.showGroupNumbers)
            SHOW_HISTORIES = 3;



        return (
            <TranslationManager.Context.Consumer>
                {(translationContext) => (
                    <React.Fragment>
                        <div className="table-s13-wrapper"
                            style={{
                                maxHeight: "calc(100vh - 100px)",
                                overflowY: "auto",
                                overflowX: "none"
                            }}
                        >
                            <div style={{ padding: "0.25em", boxSizing: "border-box" }}>
                                {translationContext.getTranslation("$history_from")}
                                &nbsp;
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.dateFrom}
                                    onChange={newDate => this.setState({ dateFrom: new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()) })}
                                    dateFormat="dd.MM.yyyy"
                                />
                            </div>

                            <div>
                                <button onClick={() => {
                                    this.setState({ exporting: true }, () => {
                                        exportPdf((percents) => {
                                            this.setState({ exportPercentage: percents });
                                            if (percents >= 100) {
                                                setTimeout(() => {
                                                    this.setState({ exportPercentage: 0, exporting: false });
                                                }, 200);
                                            }
                                        });
                                    });
                                }} disabled={this.state.exporting}>
                                    {translationContext.getTranslation("$s13_pdf")}
                                </button>

                                {this.state.exporting ?
                                    <React.Fragment>
                                        <span>
                                            &nbsp;Exporting PDF... {this.state.exportPercentage + "%"}
                                        </span>
                                    </React.Fragment> : null}
                            </div>

                            <div id="print-root">
                                {this.renderPages(translationContext, SHOW_HISTORIES, ROWS_PER_PAGE)}
                            </div>
                        </div>

                    </React.Fragment>

                )}</TranslationManager.Context.Consumer>);
    }
}

